import { render } from "./OrgSelector.vue?vue&type=template&id=27c8d53a&scoped=true"
import script from "./OrgSelector.vue?vue&type=script&lang=js"
export * from "./OrgSelector.vue?vue&type=script&lang=js"

import "./OrgSelector.vue?vue&type=style&index=0&id=27c8d53a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c8d53a"]])

export default __exports__